var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 122,
    viewBox: "0 0 133 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6709 12.2237C66.7887 12.3415 66.9057 12.46 67.0217 12.579L67.0235 12.5772L67.0262 12.5799C82.0877 -2.10358 106.201 -1.98666 121.118 12.9307C136.035 27.848 136.152 51.9612 121.469 67.0227L121.471 67.0245L121.276 67.2192C121.224 67.2722 121.171 67.3251 121.118 67.3779C121.065 67.4307 121.012 67.4833 120.959 67.5357L67.0235 121.472L12.5763 67.0245L12.579 67.0217C12.46 66.9057 12.3415 66.7887 12.2237 66.6709C-2.81153 51.6357 -2.81153 27.2588 12.2237 12.2237C27.2588 -2.81153 51.6357 -2.81153 66.6709 12.2237Z",
    fill: "#0CC608"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.de6f683e1d9b89325ff18274f90acbb2.svg";
export { ForwardRef as ReactComponent };